// GENERATED by scripts/generate-bpoint-engine.cjs; edit bpointFlow.cjs only.
// Fonte unica per Node e browser. Il prebuild genera bpointFlow.browser.js con
// export ESM: CRA tratta i file .cjs come asset, non come moduli JavaScript.
// Nessuna identità ricavata da prezzo o confini.
const DEFINITIONS = [
  [427, 'standard', 'Standard BPoint', 1, null],
  [427, 'alfieri', 'Alfieri', 1, null],
  [447, '', 'Assistenza sanitaria integrativa', 1, null],
  [456, 'infinity', 'Paghe Infinity · colonna Infoday', 0, null],
  [456, 'manuale', 'Manuale', 0, null],
  [461, '', 'Pubblicazione documentale HR Portal', 1, null],
  [462, '', 'Pubblicazione documentale dipendenti HR Portal', 1, null],
  [458, '', 'Stampe per bilancio (IRAP - ISA - ratei)', 1, null],
  [1420, '', 'Trasmissione telematica 770 subordinati', 1, null],
  [1415, '', 'Prospetto informativo disabili · quota base', 1, null],
].map(([code, tipo, title, start, end]) => ({
  id: `${code}:${tipo || 'base'}`, code, tipo, title, start, end,
  table: `bpoint_${code}_tariffe`, collection: code === 427 ? 'fasce' : `fasce${code}`,
  minField: code === 427 ? 'min_cedolini' : 'min_dipendenti',
  maxField: code === 427 ? 'max_cedolini' : 'max_dipendenti',
  priceField: code === 456 ? 'importo' : 'importo_unitario',
}));
DEFINITIONS.find((config) => config.code === 1420).initialRows = [
  [1,3,160],[4,5,200],[6,10,230],[11,15,250],[16,50,300],
  [51,100,400],[101,150,500],[151,200,600],[201,300,750],[301,400,900],[401,null,1000],
].map(([min,max,price]) => ({ min,max,price }));
DEFINITIONS.find(config => config.code === 458).initialRows = [
  [1,10,35],[11,25,50],[26,50,80],[51,100,150],[101,null,250],
].map(([min,max,price]) => ({ min,max,price }));
DEFINITIONS.find(config => config.code === 1415).initialRows = [
  [1,35,140],[36,50,160],[51,100,180],[101,null,200],
].map(([min,max,price]) => ({min,max,price}));
const PARAMETERS = [
  ['quota_base_trimestrale', 442, 'Quota base trimestrale', 50],
  ['quota_per_cedolino_edile', 442, 'Quota per edile', 1],
  ['quota_per_cedolino_dirigente', 446, 'Quota per dirigente', 9],
  ['quota_per_fondo', 448, 'Quota mensile per fondo', 5],
  ['quota_per_iscritto', 448, 'Quota mensile per iscritto', 0.75],
  ['quota_1422_quantita', 1422, 'Importo per quantità', 70],
  ['quota_1422_rateazione', 1422, 'Supplemento rateazione', 25],
  ['quota_1422_presunto', 1422, 'Supplemento riduzione del presunto', 30],
  ['quota_1415_provincia', 1415, 'Quota per provincia', 20],
  ['tetto_1415', 1415, 'Tetto massimo complessivo', 500],
].map(([field, code, title, initial]) => ({ id: `parametro:${field}`, field, code, title, initial, parameter: true }));
const CONFIG = [...DEFINITIONS, ...PARAMETERS];
const clone = (value) => JSON.parse(JSON.stringify(value));
const equal = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const dateSql = (value) => value instanceof Date
  ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
  : String(value).slice(0, 10);
const validDate = (value) => /^\d{4}-(0[1-9]|1[0-2])-01$/.test(value);
const fail = (message) => { throw new Error(message); };
const money = (value) => {
  if (value === '' || value == null || !Number.isFinite(Number(value)) || Number(value) < 0 || Number(value) > 99999999.99) fail('Importo non valido');
  return Math.round(Number(value) * 100) / 100;
};
function validate(rows, config) {
  if (!rows.length || rows[0].min !== config.start) fail(`La prima fascia deve iniziare da ${config.start}`);
  if (new Set(rows.map((row) => row.id)).size !== rows.length) fail('Identità fascia duplicata');
  rows.forEach((row, i) => {
    if (!Number.isSafeInteger(row.min) || row.min < config.start || row.min > 100000000
      || (row.max !== null && (!Number.isSafeInteger(row.max) || row.max < row.min || row.max > 100000000))
      || (i < rows.length - 1 && row.max === null)
      || (i > 0 && rows[i - 1].max + 1 !== row.min)) fail('Le fasce devono essere consecutive e valide');
    money(row.price);
  });
  if (rows[rows.length - 1].max !== config.end) fail(`L’ultima fascia deve terminare a ${config.end ?? '∞'}`);
  return rows;
}

// Ogni preview deve partire dalla fotografia all'inizio dell'editing, non
// dalla preview precedente: digitare 18 → 19 → 18 ripristina tutte le righe.
function editBoundary(rows, bandId, field, value, config) {
  const next = clone(rows);
  const index = next.findIndex((row) => row.id === bandId);
  if (index < 0) fail('Fascia non più presente');
  if (!['min', 'max'].includes(field) || value === '' || value == null || !Number.isSafeInteger(Number(value))) fail('Confine non valido');
  const number = Number(value);
  next[index][field] = number;
  if (field === 'max') {
    for (let i = index + 1; i < next.length; i += 1) {
      next[i].min = next[i - 1].max + 1;
      if (i < next.length - 1) next[i].max = Math.max(next[i].min, next[i].max);
    }
  } else {
    for (let i = index - 1; i >= 0; i -= 1) {
      next[i].max = next[i + 1].min - 1;
      if (i > 0) next[i].min = Math.min(next[i].min, next[i].max);
    }
  }
  return validate(next, config);
}

function applyOperation(rows, operation, config) {
  if (config.parameter) {
    if (operation.kind !== 'price') fail('Operazione parametro non valida');
    return [{ ...rows[0], price: money(operation.value) }];
  }
  if (operation.kind === 'boundary') return editBoundary(rows, operation.bandId, operation.field, operation.value, config);
  if (operation.kind === 'price') {
    if (!rows.some((row) => row.id === operation.bandId)) fail('La fascia non esiste in questa decorrenza');
    return rows.map((row) => row.id === operation.bandId ? { ...row, price: money(operation.value) } : row);
  }
  // Eventi importati: non attribuiamo un autore che il vecchio DB non conosce.
  if (operation.kind === 'legacy_reset') return validate(clone(operation.rows), config);
  if (operation.kind === 'legacy_ranges') {
    const next = rows.map((row) => ({ ...row, ...(operation.ranges[row.id] || {}) }));
    return validate(next, config);
  }
  fail('Operazione sconosciuta');
}

function replay(group) {
  const config = CONFIG.find((item) => item.id === group.id);
  let rows = clone(group.initial.rows);
  const steps = [{ id: null, date: group.initial.date, rows: clone(rows), initial: true, legacy: true }];
  const events = group.events.filter((event) => !event.deletedAt)
    .sort((a, b) => a.date.localeCompare(b.date) || a.sequence - b.sequence);
  for (const event of events) {
    try { rows = applyOperation(rows, event.operation, config); }
    catch (error) { fail(`${config.title}, decorrenza ${event.date}: ${error.message}`); }
    steps.push({ ...event, rows: clone(rows) });
  }
  return steps;
}
function effective(group, date) {
  return replay(group).filter((step) => step.date <= date).slice(-1)[0]?.rows || [];
}
function history(group, bandId, scope) {
  let previous;
  const entries = [];
  for (const step of replay(group)) {
    const row = step.rows.find((item) => item.id === bandId);
    const value = !row ? null : scope === 'price' ? row.price : [row.min, row.max];
    if (row && !equal(value, previous)) entries.push({
      eventId: step.id, date: step.date, value, legacy: step.legacy || false,
      author: step.author || null, recordedAt: step.recordedAt || null,
      initial: previous == null, deletable: !!step.id && step.operation?.kind !== 'legacy_reset',
      coupled: ['boundary', 'legacy_ranges'].includes(step.operation?.kind),
    });
    previous = value;
  }
  return entries.reverse();
}

// Importazione conservativa: una variazione nel numero di righe apre un nuovo
// insieme di identità. Non indoviniamo collegamenti attraverso importi uguali.
function importGroup(config, snapshots) {
  const dates = Object.keys(snapshots).sort();
  if (!dates.length) fail(`Mancano tariffe per ${config.title}`);
  let previous = [];
  const group = { id: config.id, events: [], legacyDates: dates };
  dates.forEach((date, version) => {
    const source = snapshots[date];
    const reset = previous.length !== source.length;
    const rows = source.map((row, i) => ({ ...row, id: reset ? `${config.id}:${date}:${i}` : previous[i].id }));
    if (!config.parameter) validate(rows, config);
    const push = (suffix, operation) => group.events.push({ id: `legacy:${config.id}:${date}:${suffix}`, date,
      sequence: group.events.length + 1, legacy: true, author: null, operation });
    if (version === 0) group.initial = { date, rows };
    else if (reset) push('structure', { kind: 'legacy_reset', rows });
    else {
      const ranges = {};
      rows.forEach((row, i) => {
        if (!equal([row.min, row.max], [previous[i].min, previous[i].max])) ranges[row.id] = { min: row.min, max: row.max };
      });
      if (Object.keys(ranges).length) push('ranges', { kind: 'legacy_ranges', ranges });
      rows.forEach((row, i) => {
        if (row.price !== previous[i].price) push(`price:${i}`, { kind: 'price', bandId: row.id, value: row.price });
      });
    }
    previous = rows;
  });
  return group;
}
function upgradeDocument(source) {
  const document = clone(source);
  document.groups ||= {};
  for (const config of DEFINITIONS) {
    const group = document.groups?.[config.id];
    if (!group && config.initialRows) {
      document.groups[config.id] = importGroup(config, { '2026-01-01': config.initialRows });
      continue;
    }
    if (!group) continue;
    const normalizeLast = (rows) => {
      if (Array.isArray(rows) && rows.length) rows[rows.length - 1].max = config.end;
    };
    normalizeLast(group.initial?.rows);
    (group.events || []).forEach((event) => {
      if (event.operation?.kind === 'legacy_reset') normalizeLast(event.operation.rows);
      if (event.operation?.kind === 'legacy_ranges') {
        const lastId = group.initial?.rows?.slice(-1)[0]?.id;
        if (lastId && event.operation.ranges?.[lastId]) event.operation.ranges[lastId].max = config.end;
      }
    });
  }
  for (const config of PARAMETERS) {
    if (!document.groups[config.id]) {
      document.groups[config.id] = importGroup(config, { '2026-01-01': [{ price: config.initial }] });
    }
  }
  document.version = 2;
  return document;
}
function appendOperation(group, { id, date, operation, author, recordedAt }) {
  if (!validDate(date) || date < group.initial.date) fail('Decorrenza non valida o precedente alla tariffa iniziale');
  const config = CONFIG.find((item) => item.id === group.id);
  if (!['price', 'boundary'].includes(operation?.kind)) fail('Operazione non consentita');
  const current = effective(group, date);
  const next = applyOperation(current, operation, config);
  if (equal(current, next)) return group;
  const result = clone(group);
  result.events.push({ id, date, operation, author, recordedAt, sequence: Math.max(0, ...group.events.map((e) => e.sequence)) + 1 });
  replay(result); // Verifica anche tutte le decorrenze future, prima di scrivere.
  return result;
}
function removeOperation(group, eventId, author, recordedAt) {
  const event = group.events.find((item) => item.id === eventId && !item.deletedAt);
  if (!event || event.operation.kind === 'legacy_reset') fail('Variazione non eliminabile');
  const result = clone(group);
  Object.assign(result.events.find((item) => item.id === eventId), { deletedAt: recordedAt, deletedBy: author });
  replay(result);
  return result;
}
export { DEFINITIONS, PARAMETERS, CONFIG, clone, equal, dateSql, validDate, money, validate,
  editBoundary, applyOperation, replay, effective, history, importGroup, upgradeDocument,
  appendOperation, removeOperation };
